import React from "react";
import PropTypes from "prop-types";

import { cn } from "utils";

/** Shared form field label: Inter Medium, slate-700. Default size is 14px. */
export const FORM_LABEL_CLASSNAME =
  "font-inter text-sm font-medium text-slate-700";

/** Match Modal / larger field labels: Inter Medium 16px, slate-700. */
export const FORM_LABEL_BASE_CLASSNAME =
  "font-inter text-base font-medium text-slate-700";

/** Shared text input / textarea field styles used across the new modals. */
export const FORM_INPUT_CLASSNAME =
  "rounded-md border border-solid border-slate-300 bg-white font-inter text-sm font-medium text-slate-700 focus:border-slate-300";

const SIZE_CLASSNAME = {
  sm: FORM_LABEL_CLASSNAME,
  base: FORM_LABEL_BASE_CLASSNAME,
};

/**
 * Standard form label. Use `size="base"` when the design calls for 16px
 * (e.g. Application Questions). Extra spacing belongs in `className`.
 */
const FormLabel = ({
  children,
  htmlFor,
  size = "sm",
  required = false,
  className,
  ...props
}) => {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(SIZE_CLASSNAME[size] || SIZE_CLASSNAME.sm, className)}
      {...props}
    >
      {children}
      {required ? <span className="text-red-600"> *</span> : null}
    </label>
  );
};

FormLabel.propTypes = {
  children: PropTypes.node,
  htmlFor: PropTypes.string,
  size: PropTypes.oneOf(["sm", "base"]),
  required: PropTypes.bool,
  className: PropTypes.string,
};

FormLabel.defaultProps = {
  children: null,
  htmlFor: undefined,
  size: "sm",
  required: false,
  className: "",
};

export default FormLabel;
